import FormsBaseField from "./forms-base-field.vue";

export default {
    mixins: [
        FormsBaseField
    ],
    props: {
        options: Array
    },
    data() {
        return {
            focusedOption: null,
            focusedOptionValue: '',
            selecting: false
        };
    },
    computed: {
        selectOptions() {
            return this.options?.length ? this.options : this.field.options;
        }
    },
    created() {
        this.handleClickOutsideElementEvent();
    },
    mounted() {
        if (this.$refs.selector) {
            this.handleKeyboardEvents();
        }
    },
    watch: {
        focusedOption() {
            this.selectOptions.forEach(option => option.focused = false);

            if (this.focusedOption) {
                this.focusedOptionValue = this.focusedOption.dataset.value;
                const foundOptionIndex = this.selectOptions.findIndex(option =>  option.value === this.focusedOptionValue);

                if (foundOptionIndex > -1) {
                    const option = {
                        ...this.selectOptions[foundOptionIndex],
                        focused: true
                    };

                    Vue.set(this.selectOptions, foundOptionIndex, option);
                     
                    this.$forceUpdate();

                    this.$refs.selector.scrollTop = foundOptionIndex * this.focusedOption.getBoundingClientRect().height;
                } 
            }
        },
        userInput() {
            const option = this.field.options?.find(option => option.value.toLowerCase() === this.userInput.toLowerCase());

            if (option) {
                this.userInput = option.value;
            }

            this.validateField();

            this.updateState(state => state.userInput = this.userInput);
            this.onInnerFieldStateUpdate(this.state);
        },
        selecting() {
            this.focused = this.selecting;
        }
    },
    methods: {
        handleClickOutsideElementEvent() {
            window.addEventListener('click', event => {
                if (this.selecting
                    && !this.$el.contains(event.target)) {
                    this.selecting = false;
                }
            });
        },
        handleKeyArrowDown(event) {
            event.preventDefault();

            const nextOption = this.focusedOption.nextElementSibling;

            if (nextOption) {
                this.focusedOption = nextOption;
            }
        },
        handleKeyArrowUp(event) {
            event.preventDefault();

            const previousOption = this.focusedOption.previousElementSibling;

            if (previousOption) {
                this.focusedOption = previousOption;
            }
        },
        handleKeyDefault(event) {
            event.preventDefault();

            const regexOnlyAlphabetCharacters = /^[a-z]+$/;
            const key = event.key.toLowerCase();

            if (event.key.length === 1
                && regexOnlyAlphabetCharacters.test(key)) {

                const foundMatchingOptions = Array.from(this.$refs.selector.querySelectorAll(`[data-value^='${key}' i]`));

                if (this.focusedOption
                    && this.focusedOptionValue.toLowerCase().startsWith(key)) {
                    const focusedOptionIndex = foundMatchingOptions.findIndex(matchingOption => matchingOption.dataset.value === this.focusedOptionValue);
                    const nextOptionIndex = focusedOptionIndex + 1;

                    if (focusedOptionIndex > -1
                        && nextOptionIndex < foundMatchingOptions.length) {
                        this.focusedOption = foundMatchingOptions[nextOptionIndex];
                    } else {
                        this.focusedOption = foundMatchingOptions[0];
                    }
                } else {
                    this.focusedOption = foundMatchingOptions[0];
                }
            }
        },
        handleKeyEnter(event) {
            event.preventDefault();

            if (this.focusedOption
                && !event.repeat) {
                this.select(this.focusedOptionValue);
            }
        },
        handleKeyEscape(event) {
            event.preventDefault();

            if (!event.repeat) {
                this.selecting = false;
            }
        },
        handleKeyboardEvents() {
            document.addEventListener('keydown', event => {
                if (!event?.key) {
                    return;
                }

                if (this.focused) {
                    
                    if (!this.focusedOption) {
                        this.focusedOption = this.$refs.selector.querySelector('li');
                    }

                    switch (event.key) {
                        case 'ArrowDown':
                            return this.handleKeyArrowDown(event);
                        case 'ArrowUp':
                            return this.handleKeyArrowUp(event);
                        case 'Enter':
                            return this.handleKeyEnter(event);
                        case 'Escape':
                            return this.handleKeyEscape(event);
                        default:
                            return this.handleKeyDefault(event);
                    }
                }
            });
        },
        getOptionText(optionValue) {
            const fallbackValue = this.labelsAboveFields ? this.placeholder : '';

            return this.selectOptions?.find(option => option.value === optionValue)?.text || fallbackValue;
        },
        onInnerFieldStateUpdate(state) {
            if (state.userInput !== this.userInput) {
                this.userInput = state.userInput;
            }
        },
        onOptionChange(event) {
            this.select(event.target.value);
        },
        onSelecting() {
            this.selecting = !this.selecting;
        },
        select(value) {
            this.setUserInput(value);
            this.selecting = false;
        }
    }
};